//For onetrust cookie consent pop-up
document.addEventListener('click', function (event) {
    const target = event.target.closest('a[href="#one-trust-consent"]');
    if (!target) return;

    event.preventDefault();

    if (window.OneTrust && typeof OneTrust.ToggleInfoDisplay === 'function') {
        OneTrust.ToggleInfoDisplay();
    } else {
        console.warn('OneTrust is not available on window');
    }
});

//For GA/GTM click event tracking
document.addEventListener("click", function (e) {
    const target = e.target.closest(".gtm-event");
    if (!target) return;

    const action = target.dataset.action || '';
    const category = target.dataset.category || 'event_informational_action';
    const label = target.dataset.label || '';
    const value = 0;

    AnalyticsStore(action, label, category, value);
    
});

function AnalyticsStore(action, label, category, value = 0) {
    if (!action) return;

    const payload = {
        event: 'customEvent',
        GAeventCategory: category,
        GAeventAction: action,
        GAeventLabel: label,
        GAeventValue: value,
    };

     // Push to local dataLayer for GTM
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    window.dataLayer.push(payload);
     
}
